import { findAll, register } from '../../../../Javascript/Sysmex/Utils'

const AmrJourney = el => {
  const gsap = window.gsap
  const ScrollTrigger = window.ScrollTrigger
  const Linear = window.Linear

  gsap.registerPlugin(ScrollTrigger)

  /**
   * AST parallax
   */
  const mainHeadlinesAST = findAll('.sysmexeuropeOrganismAmrJourney_main-headline-wrapper-ast')

  gsap.set(mainHeadlinesAST, {
    yPercent: 40
  })

  gsap.to(mainHeadlinesAST, {
    yPercent: -40,
    ease: 'none',
    scrollTrigger: {
      trigger: '.sysmexeuropeOrganismAmrJourney_ast-headline',
      // start: "top bottom", // default values
      end: 'top top',
      scrub: true
    }
  })

  gsap.to('.sysmexeuropeOrganismAmrJourney_ast-image', {
    yPercent: 50,
    ease: 'none',
    scrollTrigger: {
      trigger: '.sysmexeuropeOrganismAmrJourney_ast-image',
      // start: 'top bottom', // default values
      end: 'bottom+=200 top',
      scrub: true
    }
  })

  /**
   * UTI parallax
   */
  const mainHeadlinesUTI = findAll('.sysmexeuropeOrganismAmrJourney_main-headline-wrapper-uti')

  gsap.set(mainHeadlinesUTI, {
    yPercent: 40
  })

  gsap.to(mainHeadlinesUTI, {
    yPercent: -40,
    ease: 'none',
    scrollTrigger: {
      trigger: '.sysmexeuropeOrganismAmrJourney_uti-headline',
      // start: "top bottom", // default values
      end: 'top top',
      scrub: true
    }
  })

  gsap.to('.sysmexeuropeOrganismAmrJourney_bacteria-image', {
    yPercent: 50,
    ease: 'none',
    scrollTrigger: {
      trigger: '.sysmexeuropeOrganismAmrJourney_bacteria-image',
      // start: 'top bottom', // default values
      end: 'bottom+=200 top',
      scrub: true
    }
  })

  /**
   * Marquee
   */
  const marquee = document.querySelectorAll('.sysmexeuropeOrganismAmrJourney_marquee-text')

  // get the correct width
  window.addEventListener('load', () => {
    marquee.forEach(el => {
      const rate = 50 // speed
      const distance = el.clientWidth
      // get the margin-right of the element
      const style = window.getComputedStyle(el)
      const marginRight = parseInt(style.marginRight) || 0
      // get the total width of the element
      const totalDistance = distance + marginRight
      // get the duration of the animation
      const time = totalDistance / rate
      // get the parent of the element
      const container = el.parentElement

      gsap.to(container, time, {
        repeat: -1,
        x: '-' + totalDistance,
        ease: Linear.easeNone
      })
    })
  })

  /**
   * Carousel slider
   */
  const initSlider = () => {
    const Splide = window.Splide
    const sliderContainer = el.querySelector('.slider-wrapper')

    const paddedSlider = new Splide(sliderContainer, {
      type: 'loop',
      perPage: 3,
      padding: '5rem',
      autoHeight: true,
      pagination: false,
      arrows: false,
      gap: '2rem',
      focus: 'center',
      breakpoints: {
        1100: {
          perPage: 1,
          padding: '3rem',
          gap: '1rem'
        }
      }
    })

    paddedSlider.mount()

    paddedSlider.on('click', slide => paddedSlider.go(slide.index))
  }

  initSlider()

  /**
   * Reveal headlines
   */
  const maskWrapperA = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_mask-wrapper-a')
  const textMaskA = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_text-mask-a')
  const maskedTextA = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_masked-text-a')

  const maskWrapperB = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_mask-wrapper-b')
  const textMaskB = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_text-mask-b')
  const maskedTextB = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_masked-text-b')

  const maskWrapperC = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_mask-wrapper-c')
  const textMaskC = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_text-mask-c')
  const maskedTextC = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_masked-text-c')

  const maskWrapperD = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_mask-wrapper-d')
  const textMaskD = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_text-mask-d')
  const maskedTextD = gsap.utils.toArray('.sysmexeuropeOrganismAmrJourney_masked-text-d')

  gsap.set([maskWrapperA, maskWrapperB, maskWrapperC], { y: 0 })
  gsap.set([textMaskA, textMaskB, textMaskC], { yPercent: -50 })
  gsap.set([maskedTextA, maskedTextB, maskedTextC], { yPercent: 150 })
  gsap.set([maskedTextD, maskedTextD, maskedTextD], { yPercent: 150 })

  const tl1 = gsap.timeline({
    scrollTrigger: {
      start: 'top bottom-=200',
      trigger: maskWrapperA
    }
  })
  tl1.to([maskWrapperA, textMaskA, maskedTextA], { yPercent: 0, duration: 1, stagger: 0.1 })

  const tl2 = gsap.timeline({
    scrollTrigger: {
      start: 'top bottom-=200',
      trigger: maskWrapperB
    }
  })
  tl2.to([maskWrapperB, textMaskB, maskedTextB], { yPercent: 0, duration: 1, stagger: 0.1 })

  const tl3 = gsap.timeline({
    scrollTrigger: {
      start: 'top bottom-=200',
      trigger: maskWrapperC
    }
  })
  tl3.to([maskWrapperC, textMaskC, maskedTextC], { yPercent: 0, duration: 1, stagger: 0.1 })

  const tl4 = gsap.timeline({
    scrollTrigger: {
      start: 'top bottom-=200',
      trigger: maskWrapperD
    }
  })
  tl4.to([maskWrapperD, textMaskD, maskedTextD], { yPercent: 0, duration: 1, stagger: 0.1 })
}

register('AmrJourney', AmrJourney)
